import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Package, Shield, Globe, Clock, TrendingUp, Award, Mail, Phone } from 'lucide-react';
import { companyInfo, leatherCategories, whyChooseUs } from '../data/mock';

export const Home = () => {
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate('/contact');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="bg-[#FAF8F3]">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img
            src="https://images.pexels.com/photos/4452511/pexels-photo-4452511.jpeg"
            alt="Premium Leather Manufacturing"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>

        <div className="hero-content w-full">
          <div className="max-w-2xl">
            <h1 className="hero-title">
              {companyInfo.name}
            </h1>
            <div className="accent-line"></div>
            <p className="text-[#FAF8F3] text-xl md:text-2xl mb-8 leading-relaxed font-light">
              {companyInfo.tagline}
            </p>
            <p className="text-[#D4A574] text-lg mb-10 leading-relaxed max-w-xl">
              Your trusted partner for premium leather goods export from India to global markets.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/about" className="btn-primary">
                Learn More <ArrowRight size={20} />
              </Link>
              <Link to="/contact" className="btn-secondary" style={{color: '#FAF8F3', borderColor: '#FAF8F3'}}>
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Brief About Section */}
      <section className="section section-light">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="section-title">About Pravak Global Exports</h2>
            <div className="accent-line mx-auto"></div>
          </div>
          <p className="section-subtitle text-center max-w-4xl mx-auto">
            {companyInfo.description}
          </p>
        </div>
      </section>

      {/* Our Focus - Leather Categories */}
      <section className="section section-accent">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="section-title">Our Focus Areas</h2>
            <div className="accent-line mx-auto"></div>
            <p className="section-subtitle max-w-3xl mx-auto mt-6">
              Specializing in premium leather goods export, we focus on three core product categories for international markets.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {leatherCategories.map((category) => (
              <div key={category.id} className="category-card">
                <div className="icon-wrapper">
                  <Package size={28} />
                </div>
                <h3 className="text-2xl font-bold mb-4" style={{color: '#2C1810', fontFamily: 'Playfair Display, serif'}}>
                  {category.title}
                </h3>
                <p className="body-text">{category.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section section-light">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="section-title">Why Choose Pravak Global Exports</h2>
            <div className="accent-line mx-auto"></div>
            <p className="section-subtitle max-w-3xl mx-auto mt-6">
              We combine traditional Indian craftsmanship with modern export excellence to deliver exceptional value to our international partners.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => {
              const icons = [Shield, Globe, TrendingUp, Award, Clock, Package];
              const Icon = icons[index % icons.length];
              return (
                <div key={item.id} className="feature-card">
                  <div style={{color: '#8B4513'}} className="mb-4">
                    <Icon size={40} />
                  </div>
                  <h3 className="text-xl font-bold mb-3" style={{color: '#2C1810'}}>{item.title}</h3>
                  <p className="body-text text-sm">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-dark">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="section-title" style={{color: '#FAF8F3'}}>Ready to Partner with Us?</h2>
          <div className="accent-line mx-auto"></div>
          <p className="section-subtitle mt-6 mb-8" style={{color: '#D4A574'}}>
            Get in touch to discuss your leather goods requirements. We're committed to building long-term partnerships and delivering excellence in every shipment.
          </p>
          
          {/* Contact Info */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            <a href="mailto:support@pravakglobalexports.com" className="flex items-center gap-3 text-[#D4A574] hover:text-[#d9fb06] transition-colors">
              <Mail size={24} />
              <span className="text-lg font-medium">support@pravakglobalexports.com</span>
            </a>
            <a href="tel:+919085904210" className="flex items-center gap-3 text-[#D4A574] hover:text-[#d9fb06] transition-colors">
              <Phone size={24} />
              <span className="text-lg font-medium">+91 90859 04210</span>
            </a>
          </div>
          
          <a href="/contact" onClick={handleContactClick} className="btn-primary">
            Contact Us Now <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};